'use client';

import { Box, Flex } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

import Cell from './Cell';

const Row = ({ children, ...restProps }: { children: ReactNode }) => (
  <Box
    sx={theme => ({
      '&:has(li:empty):not(:has(li:not(:empty)))': {
        display: 'none'
      },
      listStyleType: 'none',
      padding: '0',
      ul: { listStyleType: 'none', padding: 0, margin: 0 },
      li: {
        margin: '0 !important',
        '&:first-of-type': {
          paddingLeft: '0 !important',
          position: 'sticky',
          left: 0,
          background: theme.color.background.base,
          zIndex: 2,
          display: 'none'
        },
        '&:nth-of-type(2)': { paddingLeft: '0 !important' },
        [theme.breakpoint.minWidth('lg')]: { '&:first-of-type': { display: 'block' } }
      }
    })}
    {...restProps}
  >
    <Flex component='ul'>
      <Cell></Cell>
      {children}
    </Flex>
  </Box>
);

export default Row;
